
const {ccclass, property} = cc._decorator;

const g_eventList = {
    [cc.Node.EventType.TOUCH_START]: "touchEventStart",
    [cc.Node.EventType.TOUCH_MOVE]: "touchEventMove",
    [cc.Node.EventType.TOUCH_END]: "touchEventEnd",
    [cc.Node.EventType.TOUCH_CANCEL]: "touchEventCancel",
}
@ccclass
export default class BaseComponent extends cc.Component {
    
    /** 事件节点 */
    private _eventNode: cc.Node = null; 
    /** 是否点击关闭层 */
    private _bTouchEndCloseLayer: boolean = false;

    /** 是否初始化 */
    private bInit = false;

    protected _carryData = null;
    
    setCarryData(_carryData: any) {
        this._carryData = _carryData;
    }

    onLoad () {
        this.bInit = true;
    }

    isInit() {
        return this.bInit;
    }


    /**
     * 初始化点击事件
     * @param node 添加点击事件的节点
     * @param bTouchEndCloseLayer 是否点击结束关闭层
     */
    initTouchEvent(node: cc.Node, bTouchEndCloseLayer: boolean = false){
        this._eventNode = node;
        this._bTouchEndCloseLayer = bTouchEndCloseLayer;
        for (let s in g_eventList) {
            if(this._eventNode)
            {
                this._eventNode.on(s, this[g_eventList[s]], this);
            }
        }
    }

    offTouchEvent() {
        if (!this._eventNode) {
            return;
        }
        for (let s in g_eventList) {
            this._eventNode.off(s, this[g_eventList[s]], this);
        }
    }

    touchEventStart(event: cc.Event.EventTouch){

    }

    touchEventMove(event: cc.Event.EventTouch){

    }

    touchEventEnd(event: cc.Event.EventTouch){
        if (this._bTouchEndCloseLayer) {
            this.destroyNode();
                // 关闭音效
        }
    }

    touchEventCancel(event: cc.Event.EventTouch){

    }

     /**
     * 关闭
     */
     destroyNode() {
        this.node.destroy();
    }
}
